export const getAddressDetails = ({ state }) => state.addressDetailsReducer.addressDetails;
export const getAddressExtraDetails = ({ state }) => state.addressDetailsReducer.addressExtraDetails;
